module.exports = __webpack_public_path__ + "img/max10.4fa43f65.jpg";